export const returnBookStatus = [
  { id: "shouldBeReturned", name: "Return", value: true },
  { id: "shouldNotBeReturned", name: "No Return", value: false },
];

export const getReturnBookStatus = (state) => {
  return returnBookStatus.find((x) => x.value === state);
};

export const returnBookPurchase = [
  { id: "no-purchase", name: "Not purchase", value: false },
  { id: "purchase", name: "Purchase", value: true },
];

export const getReturnBookPurchase = (state) => {
  return returnBookPurchase.find((x) => x.value === state);
};

export const summaryPurchaseOptions = [
  { id: "all", name: "All", value: "all" },
  { id: "no-purchase", name: "NoPurchase", value: "no-purchase" },
  { id: "purchase", name: "Purchase", value: "purchase" },
];